import { useEffect, useState } from "react";

import Cookies from "js-cookie";

import useUser from "./useUser";
import {
  setUnverifiedModalOpen,
  showUnverifiedDisabledModal,
  setTriggerPoint
} from "@/redux/features/unverified-modal/slice";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";

const useUnverifiedModal = (isUnverifiedEnabled, callbackFunction) => {
  const dispatch = useAppDispatch();
  const { isRegisteredUserLoggedIn, isUnverfiedUserLoggedIn } = useUser();
  let cookiePassthrough = false;
  const {
    triggerPoint,
    modalStatus,
    isModalOpen,
    setUnverifiedDisabledModalOpen
  } = useAppSelector((state) => state.unverifiedModal);
  const { isTriggeredPointActive } = triggerPoint;
  const [isProceedAllowed, setIsProceedAllowed] = useState(false);
  const cookieValues = Cookies.get("trigger_point");
  let cookieTriggerPoint;
  if (cookieValues) {
    cookieTriggerPoint = JSON.parse(cookieValues);
  }
  const { ideas } = useAppSelector((state) => state.brainstormers);

  useEffect(() => {
    // using the ideas value in the hook will be refactored later
    // we should be passing it from the area where we are using this hook.
    if (cookieValues && isRegisteredUserLoggedIn) {
      if (ideas.length > 0 || cookieTriggerPoint.postId === undefined) {
        dispatch(
          setTriggerPoint({ ...triggerPoint, isTriggeredPointActive: true })
        );
        cookiePassthrough = true;
        setIsProceedAllowed(true);
      }
    }
  }, [ideas]);

  useEffect(() => {
    setIsProceedAllowed(isUnverfiedUserLoggedIn || isRegisteredUserLoggedIn);
  }, [isUnverfiedUserLoggedIn, isRegisteredUserLoggedIn]);

  useEffect(() => {
    if (modalStatus === "submit") {
      dispatch(
        setTriggerPoint({ ...triggerPoint, isTriggeredPointActive: true })
      );
    } else if (modalStatus === "cancel") {
      dispatch(
        setTriggerPoint({ ...triggerPoint, isTriggeredPointActive: false })
      );
    }
  }, [modalStatus, isModalOpen, setUnverifiedDisabledModalOpen]);

  useEffect(() => {
    if (isTriggeredPointActive || cookiePassthrough) {
      if (!isRegisteredUserLoggedIn) {
        if (isUnverifiedEnabled && !isUnverfiedUserLoggedIn) {
          dispatch(showUnverifiedDisabledModal(false));
          dispatch(setUnverifiedModalOpen(true));
        } else if (!isUnverifiedEnabled && !isUnverfiedUserLoggedIn) {
          dispatch(setUnverifiedModalOpen(false));
          dispatch(showUnverifiedDisabledModal(true));
        }
      }
      const isAllowed = isProceedAllowed || cookiePassthrough;
      if (callbackFunction) callbackFunction(isAllowed);
    }
  }, [
    isTriggeredPointActive,
    callbackFunction,
    isProceedAllowed,
    isRegisteredUserLoggedIn,
    isUnverifiedEnabled,
    isUnverfiedUserLoggedIn
  ]);
};

export default useUnverifiedModal;
